// language
// eslint-disable-next-line import/prefer-default-export
export const LANGUAGE = 'rt-admin.language'
